import React from 'react';
import { ToolComponentProps } from './types';
import { ChevronRight, ChevronDown } from 'lucide-react';
import { truncatePath } from './pathUtils';

export const WriteFileTool: React.FC<ToolComponentProps> = ({ 
  input, 
  output, 
  isError,
  isExpanded,
  onToggle 
}) => {
  const path = input?.path || '';
  const displayPath = truncatePath(path);
  const content = input?.content || '';
  const hasOutput = output !== undefined && output !== null;

  return (
    <div>
      <div
        className={`flex items-center gap-1 ${hasOutput ? 'cursor-pointer hover:bg-accent/30' : ''} rounded transition-colors`}
        onClick={hasOutput ? onToggle : undefined}
        title={path} // Show full path on hover
      >
        <span className="flex-1">Write: {displayPath}</span>
        <span className="text-muted-foreground inline-block w-3">
          {hasOutput && (isExpanded ? <ChevronDown className="h-3 w-3" /> : <ChevronRight className="h-3 w-3" />)}
        </span>
      </div>

      {isExpanded && hasOutput && (
        <div className={`mt-2 rounded`}>
          {isError ? (
            <div className="p-2 rounded bg-destructive/10 text-destructive">
              <pre className="whitespace-pre-wrap">
                {typeof output === 'string' ? output : JSON.stringify(output, null, 2)}
              </pre>
            </div>
          ) : (
            <div className="bg-muted rounded">
              {/* Show the content that was written */}
              {content && (
                <div className="overflow-x-auto">
                  <pre className="whitespace-pre">{content}</pre>
                </div>
              )}

              {/* Show success message */}
              {output && (
                <div className="border-t border-background/10 text-muted-foreground">
                  {typeof output === 'string' ? output : JSON.stringify(output, null, 2)}
                </div>
              )}
            </div>
          )}
        </div>
      )}
    </div>
  );
};